// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37Whk","controls":"styles_controls__1G5_s","charLimit":"styles_charLimit__ko6ZO","input":"styles_input__1HOax","send":"styles_send__38Vgr"};